import * as React from "react";
import { SVGProps, memo } from "react";

const SvgReceiveMedicine = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={54} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill="#E5E5E5" d="M0 0h64v54H0z" />

    <g clipPath="url(#ReceiveMedicine_svg__a)">
      <path fill="#F4F7FA" d="M-53-1078h375V463H-53z" />

      <path fill="#fff" d="M-53-364h375v599H-53z" />

      <rect x={-37} y={-243} width={343} height={328} rx={10} fill="#E7F4FD" />

      <rect x={-27} y={-172} width={323} height={247} rx={10} fill="#fff" />

      <path
        d="M63.5 11.2v37.33c0 .816-.652 1.47-1.467 1.47H26.967a1.463 1.463 0 0 1-1.467-1.47V1.47c0-.816.652-1.47 1.467-1.47H52.3l11.2 11.2Z"
        fill="#F8FAFB"
      />

      <path d="M51.5 12V1l11 11h-11Z" fill="#1395EC" />

      <mask id="ReceiveMedicine_svg__b" fill="#fff">
        <path d="M63.5 11.2v37.33c0 .816-.652 1.47-1.467 1.47H26.967a1.463 1.463 0 0 1-1.467-1.47V1.47c0-.816.652-1.47 1.467-1.47H52.3l11.2 11.2Z" />
      </mask>

      <path
        d="M63.5 11.2v37.33c0 .816-.652 1.47-1.467 1.47H26.967a1.463 1.463 0 0 1-1.467-1.47V1.47c0-.816.652-1.47 1.467-1.47H52.3l11.2 11.2Z"
        stroke="#2B323B"
        strokeWidth={3.2}
        mask="url(#ReceiveMedicine_svg__b)"
      />

      <path
        d="M63.5 12H53.007a1.5 1.5 0 0 1-1.507-1.507V0"
        stroke="#2B323B"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />

      <path
        d="M31.5 30h26M31.5 35h17M31.5 40h17"
        stroke="#A3B5BB"
        strokeOpacity={0.5}
        strokeWidth={2}
        strokeLinecap="round"
      />

      <path
        d="M33.647 18.787h.867c.297 0 .493-.009.697-.034-.008.11-.026.34-.076 1.215-.094 1.25-.34 2.244-.782 3.145.348.493.713.799 1.19 1.012.467.203 1.309.314 2.413.314.434 0 .8-.017 1.65-.06-.179.451-.239.689-.298 1.165-.246.017-.68.026-.884.026-.654 0-1.751-.077-2.295-.162-.858-.136-1.674-.638-2.303-1.42-.468.655-.927 1.131-1.666 1.726a3.104 3.104 0 0 0-.689-.969c.79-.544 1.3-1.046 1.734-1.7-.238-.434-.34-.672-.527-1.224a6.475 6.475 0 0 1-.612.977c-.204-.51-.332-.713-.629-1.079.408-.536.689-1.105.91-1.879.178-.628.322-1.445.322-1.887 0-.059 0-.067-.008-.136l1.13.102a3.123 3.123 0 0 0-.076.468c-.026.153-.043.238-.068.4Zm.485.969h-.689a9.604 9.604 0 0 1-.221.747c.195.74.289 1.012.502 1.488.22-.637.323-1.19.408-2.235Zm3.11-.485h-.603c-.017 1.802-.043 2.168-.187 2.941-.136.756-.323 1.25-.671 1.785-.273-.323-.425-.45-.91-.731.297-.416.45-.799.578-1.377.136-.612.178-1.284.178-2.898 0-.383-.008-.596-.034-.774.17.017.34.026.68.026h1.25c.365 0 .578-.009.756-.026a5.975 5.975 0 0 0-.034.782v3.621c0 .11.026.127.162.127.145 0 .187-.05.213-.271.017-.196.025-.723.034-1.335.28.153.441.204.807.272-.042 1.36-.085 1.751-.23 2.014-.136.247-.407.34-1.003.34-.773 0-.986-.152-.986-.688v-3.808Zm6.604-.289v-.459c0-.289-.017-.476-.06-.689h1.292c-.034.179-.051.4-.051.689v.459h2.21c.493 0 .816-.017 1.122-.06v1.19a8.483 8.483 0 0 0-1.08-.05h-3.068c-.026.382-.042.569-.06.816h2.44c.45 0 .672-.009.884-.035-.008.06-.008.06-.017.17-.034.264-.06.612-.076 1.012-.069 1.42-.154 2.15-.323 2.712-.204.697-.544.909-1.428.909-.239 0-.443-.009-1.114-.051-.034-.425-.094-.671-.289-1.165.468.077.875.111 1.25.111.399 0 .501-.11.594-.663.085-.433.128-1.012.153-1.947h-2.218a5.992 5.992 0 0 1-.731 1.862c-.45.74-1.046 1.326-1.972 1.947a3.266 3.266 0 0 0-.808-.961c.808-.493 1.148-.79 1.59-1.369.485-.645.74-1.317.858-2.329.034-.305.051-.552.06-1.02h-1.232c-.425 0-.791.017-1.114.052v-1.19c.323.042.663.059 1.114.059h2.074Zm11.711 1.003.748-.034c.315-.017.62-.051.876-.093l.017.858c-.102-.009-.111-.009-.273-.009-.161 0-.34.009-.611.017l-.612.035.544.373c-.154.077-.154.077-.477.255a4.599 4.599 0 0 1-.501.247c.315.128.646.204.858.204.154 0 .247-.051.315-.187.085-.17.136-.366.161-.646.273.238.485.366.808.493-.161.816-.535 1.181-1.19 1.181-.629 0-1.386-.246-2.057-.662-.416.127-.756.212-1.258.314.085.23.161.357.349.62l.68-.034a3.113 3.113 0 0 0-.527-.408l.79-.271c.314.204.535.39.748.62l1.377-.068c.374-.025.637-.051.901-.102l.026.893c-.12-.009-.128-.009-.264-.009-.153 0-.434.009-.654.017l-.74.051.595.4a9.965 9.965 0 0 1-1.045.552c.365.162.773.28 1.003.28.238 0 .348-.22.425-.866.297.238.518.365.858.51-.077.365-.161.595-.306.807-.178.272-.535.442-.935.442-.62 0-1.437-.28-2.15-.731-1.123.374-2.338.587-3.775.655-.119-.4-.229-.646-.442-.97.204.009.357.009.451.009.944 0 2.04-.119 2.983-.323a5.054 5.054 0 0 1-.526-.587l-2.023.128c-.358.025-.621.051-.901.093l-.026-.943c.102.009.195.017.365.017.153 0 .332-.008.561-.017l1.471-.085c-.17-.28-.187-.306-.306-.51-.51.068-.799.102-1.496.144a3.515 3.515 0 0 0-.416-.9h.271c.978 0 2.33-.137 3.197-.315a4.289 4.289 0 0 1-.46-.51l-2.26.127c-.34.017-.638.043-.885.085l-.025-.926c.128.017.238.026.425.026.145 0 .297 0 .468-.017l1.733-.077c-.084-.145-.127-.213-.246-.442l-.34.051a3.768 3.768 0 0 0-.247-.62h-.433a4.945 4.945 0 0 1-.952.986 4.15 4.15 0 0 0-.714-.774c.688-.502 1.071-.994 1.258-1.598l1.088.162c-.051.102-.051.102-.178.348h1.079c.383 0 .553-.009.773-.043v.68c.306-.373.485-.722.587-1.147l1.08.162c-.043.093-.043.102-.094.22l-.06.136h1.462c.443 0 .613-.008.876-.042v.96a5.337 5.337 0 0 0-.825-.042h-.501c.127.187.161.238.255.408l-.918.213a4.702 4.702 0 0 0-.323-.621h-.51c-.212.323-.323.442-.637.756a4.012 4.012 0 0 0-.765-.645c.05-.051.068-.06.127-.111-.093-.009-.145-.009-.255-.009h-.468c.111.188.128.23.196.366l.45-.043c.026.188.102.374.281.638l1.02-.051a5.193 5.193 0 0 0-.383-.323l.876-.306c.187.162.306.28.578.578Zm-.178.799-1.292.068c.135.128.195.178.34.297.416-.136.62-.212.952-.365Zm-.069 2.873-1.41.085c.153.153.246.238.407.357.434-.153.782-.306 1.003-.442Z"
        fill="#0F72BD"
      />

      <mask id="ReceiveMedicine_svg__c" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.608 34.595c.874 1.613.281 3.64-1.32 4.508l-2.907 1.577S26.5 45.5 23 46.5c-3.5 1-10.464 1.151-10.464 1.151l-4.958-9.14a1.662 1.662 0 0 1 .656-2.244s5.542-7.065 10.067-10.497c3.202-2.428 8.838-5.27 8.838-5.27l-.003 9.497v5.961l4.981-2.702c1.6-.867 3.623-.259 4.49 1.34Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.608 34.595c.874 1.613.281 3.64-1.32 4.508l-2.907 1.577S26.5 45.5 23 46.5c-3.5 1-10.464 1.151-10.464 1.151l-4.958-9.14a1.662 1.662 0 0 1 .656-2.244s5.542-7.065 10.067-10.497c3.202-2.428 8.838-5.27 8.838-5.27l-.003 9.497v5.961l4.981-2.702c1.6-.867 3.623-.259 4.49 1.34Z"
        fill="#fff"
        stroke="#2B323B"
        strokeWidth={3.2}
        strokeLinejoin="round"
        mask="url(#ReceiveMedicine_svg__c)"
      />

      <mask id="ReceiveMedicine_svg__d" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.289 34.746a2 2 0 0 0-2.722-.77l-3.321 1.858a2 2 0 0 0-.77 2.721l7.662 13.7a2 2 0 0 0 2.721.769l3.321-1.858a2 2 0 0 0 .77-2.721l-7.661-13.7Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.289 34.746a2 2 0 0 0-2.722-.77l-3.321 1.858a2 2 0 0 0-.77 2.721l7.662 13.7a2 2 0 0 0 2.721.769l3.321-1.858a2 2 0 0 0 .77-2.721l-7.661-13.7Z"
        fill="#D0EAFB"
        stroke="#2B323B"
        strokeWidth={3.2}
        mask="url(#ReceiveMedicine_svg__d)"
      />
    </g>

    <defs>
      <clipPath id="ReceiveMedicine_svg__a">
        <path fill="#fff" transform="translate(-53 -1078)" d="M0 0h375v1541H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgReceiveMedicine);

export default Memo;
